import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { apiRequest } from '../modules/shared/hook/useApi';
import { IMentor, IRecommendedMentors } from '../types';
import { LikeMindedState } from './store';

interface RecommendedMentorsSlice {
  loading: boolean;
  recommendationId?: string;
  recommendedMentors: Array<IMentor>;
}

const initialState = {
  loading: false,
  recommendedMentors: [],
} as RecommendedMentorsSlice;

export const fetchRecommendedMentors = createAsyncThunk<
  IRecommendedMentors,
  void,
  {
    rejectValue: number;
  }
>('app/recommendedMentors', async (_, { rejectWithValue }) => {
  try {
    const recommendationsResponse = await apiRequest<IRecommendedMentors>(
      'getRecommendedMentors',
    );

    return recommendationsResponse;
  } catch (e) {
    Sentry.captureException(e);
    return rejectWithValue(401);
  }
});

export const recommendedMentorsSlice = createSlice({
  name: 'recommendedMentors',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchRecommendedMentors.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchRecommendedMentors.fulfilled, (state, action) => {
      state.loading = false;
      state.recommendedMentors = action?.payload?.recommendations;
      state.recommendationId = action?.payload?.id;
    });
    builder.addCase(fetchRecommendedMentors.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const recommendedMentorsReducer = recommendedMentorsSlice.reducer;
export const selectRecommendedMentors = (state: LikeMindedState) =>
  state.recommendedMentors;
